// ============================================================
// ANSICHTSSACHE-AGENT – Beschriftung eines Eingabefelds
// ============================================================
// Die EINE Beschriftung ueber einem Feld: Eingabefeld, Auswahl,
// Textfeld, Markdown-Feld. Vorher trug jedes Bauteil seine
// eigene Abschrift derselben Klassen, und ein Formular mit einem
// selbst gebauten Feld schrieb sie ein fuenftes Mal ab.
//
// `data-field-label` ist der Griff, an dem der Dialog seine Felder
// erkennt: im Modal stehen Beschriftungen in Versalien (Vorbild
// ist das Ausgaben-Modal). Im Quelltext steht die Beschriftung in
// normaler Schreibweise („Rechnungsdatum“) — WIE sie im Modal
// aussieht, entscheidet `components/ui/dialog.tsx` an einer
// Stelle, und eine Aenderung dort erreicht jedes Modal.
// ============================================================

import { cn } from "@/lib/utils";

export function FieldLabel({
  htmlFor,
  id,
  className,
  children,
}: {
  htmlFor?: string;
  id?: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <label
      htmlFor={htmlFor}
      id={id}
      data-field-label=""
      className={cn("text-body-sm text-text-secondary block font-medium", className)}
    >
      {children}
    </label>
  );
}
